import { createRouter, createWebHistory } from "vue-router";

import landing from "./domains/landing/routes";
import auth from "./domains/authentication/routes";
import sell from "./domains/sell/routes";
import product from "./domains/product-details/routes";
import Dashboard from "./domains/userdashboard/routes";
import filter from "./domains/filter/routes";
import rfp from "./domains/rfp/routes";
import checkout from "./domains/checkout/routes";
import policy from "./domains/policy/routes";
import terms from "./domains/termsOfService/routes";

import ProductDetails from "./domains/product-details/views/ProductDetails";
const Filter = () => import('./domains/filter/views/Filter');


import boutique from "./domains/boutique/routes";
import faq from "./domains/FAQ/routes";


import store from "./store";
import { CHECK_AUTH_TOKEN, CHECK_TOKEN, GET_SLUGS, SET_COUNTRY, SET_CURRENCY, SET_LOCALE } from "./common/store/actions";
import AuthHelper from "./common/helpers/AuthHelper";
import { ADD_KEYWORDS } from "./common/store/actions";
import CustomerService from "./common/services/customer/CustomerService";
import { GET_BILLING_COMPANY } from "./domains/checkout/store/actions";

const routes = [
    ...landing,
    ...sell,
    ...auth,
    ...Dashboard,
    // ...product,
    // ...filter,
    ...rfp,
    ...checkout,
    ...boutique,
    ...faq,
    ...policy,
    ...terms,

];

const withPrefix = (prefix, routes) => {
    return routes.map((route) => {
        route.path = prefix + route.path;
        return route;
    });
};

const createDynamicRoutes = async () =>
{
    await store.dispatch(GET_SLUGS)
    const routeInfo = store.getters.slugs

    let dynamicRoutes = [
        {
            path: `/${routeInfo.product_details}/:category/:brand/:id`,
            name: "kitDisplayLink",
            component: ProductDetails,
        },
        {
            path: `/${routeInfo.filter}/:category?`,
            name: "Shop",
            component: Filter,
        },
    ]

    return dynamicRoutes
}

const appendDynamicRoutes = async (staticRoutes, dynamicRoutes) => {
    

    dynamicRoutes.forEach(
        (route) =>
        {
            staticRoutes.push(route)
        }
    )
}

async function createRoutes()
{
    const dynamicRoutes = await createDynamicRoutes()
    
    await appendDynamicRoutes(routes,dynamicRoutes)

    const router = createRouter({
        history: createWebHistory(process.env.BASE_URL),
        routes: [
            // {
            //     path: "/",
            //     redirect: store.getters.homeRedirectionPath,
            // },
            ...withPrefix("/:locale", routes),
        ],
    });


    router.beforeEach(async (to, from, next) => {

        let locale = to.params.locale;
        console.log("FSFFS",locale)


        if (!store.getters.currency)
        {
            store.dispatch(SET_CURRENCY, store.getters.defaultLanguageAndCurrency.currency)
        }

        if(to.name != 'Home'){
            let keywords = {
                preferences:[]
            }
            keywords.preferences.push({
                value: to.path,
                type: "page"
            })
            store.dispatch(ADD_KEYWORDS, keywords)
        }

        console.log(locale)

        if (!locale || locale=='null') {
            locale = localStorage.getItem("locale")||store.getters.defaultLanguageAndCurrency.language.code
            store.commit(SET_LOCALE, {locale:locale})
            next({ path: store.getters.homeRedirectionPath });
            return;
        }
    
        if (locale.length != 2) {
            // store.dispatch(SET_LOCALE, "en").then(() => {
            //     next({ path: store.getters.homeRedirectionPath });
            // });
            locale = localStorage.getItem("locale")||store.getters.defaultLanguageAndCurrency.language.code
            store.commit(SET_LOCALE, {local:locale})
            next({ path: store.getters.homeRedirectionPath });
            return;
        }
    
        // if (!["en", "fr", "es",'ar'].includes(locale)) {
        //     store.dispatch(SET_LOCALE, "en").then(() => {
        //         next({ path: store.getters.homeRedirectionPath });
        //     });
    
        //     return;
        // }

        store.dispatch(SET_LOCALE, locale)

        if (to.query['clearCart']=='true')
        {
            store.commit('clearCart');
        }
        next();
    });

    return router
}

// const router = createRouter({
//     history: createWebHistory(process.env.BASE_URL),
//     routes: [{
//             path: "/",
//             redirect: store.getters.homeRedirectionPath,
//         },
//         ...withPrefix("/:locale", routes),
//     ],
// });

const routerPromise = createRoutes()
export default routerPromise;